/** Short-lived in-memory cache with in-flight deduplication (per browser tab). */

type CacheEntry<T> = { at: number; value: T };

export function createRequestCache<T>(ttlMs: number) {
  let entry: CacheEntry<T> | null = null;
  let inflight: Promise<T> | null = null;

  return {
    async get(fetcher: () => Promise<T>, options?: { force?: boolean }): Promise<T> {
      const force = options?.force === true;
      if (!force && entry && Date.now() - entry.at < ttlMs) {
        return entry.value;
      }
      if (inflight) return inflight;
      inflight = fetcher()
        .then((value) => {
          entry = { at: Date.now(), value };
          inflight = null;
          return value;
        })
        .catch((err) => {
          inflight = null;
          throw err;
        });
      return inflight;
    },
    invalidate() {
      entry = null;
    },
  };
}
